import { router } from './router';
import { store } from './store';
import { i18n } from './i18n';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { uiBlocksPlugin } from '@/shared/blocksUI';
import { install as Hades } from '@axxone-system/hades';
// import Vue3Lottie from 'vue3-lottie';
import type { App } from 'vue';

export function applyPlugins(app: App) {
    app.use(router);
    app.use(store);
    app.use(i18n);
    app.use(Hades);
    app.use(uiBlocksPlugin);
    // app.use(Vue3Lottie);
    app.use(VueQueryPlugin, {
        enableDevtoolsV6Plugin: true,
    });
}

export async function initSentry(app: App) {
    const Sentry = await import('@sentry/vue');
    Sentry.init({
        app,
        dsn: 'https://1a8df6e7d62a698fec3eaf9f0cb0b1c8@sentry.axxone.fr/3',
        integrations: [Sentry.browserTracingIntegration({
            router
        })],
        tracesSampleRate: 1.0,
        sendDefaultPii: true,
        environment: import.meta.env.MODE,
    });
}
